module.exports = __webpack_public_path__ + "img/benefits02.a222a93.png";